/**
 * Transforms an array of products using a provided transformer function.
 *
 * @param {Array} products - The array of product objects to transform.
 * @param {Function} transformer - A function that takes a product object as an argument
 *                                  and returns a transformed version of it.
 * @returns {Array} An array of transformed products, each with an added `index` property.
 */
export default (products, transformer) => {
    return products.map((product, index) => {
        return {
            index: index || 0,
            ...transformer(product),
        };
    });
};
